import wx from 'weixin-js-sdk';
import { getSignature } from '@/api/wx';
import { isIOS } from '.';

/**
 * 判断是不是微信浏览器
 * @returns {boolean}
 */
export function isWX() {
	var ua = navigator.userAgent.toLowerCase();

	return !!(
		ua.match(/MicroMessenger/i) &&
		ua.match(/MicroMessenger/i)[0] === 'micromessenger'
	);
}

/**
 *  获取微信要授权的链接
 *  1. 安卓需要使用当前URL进行微信API注册（即当场调用location.href.split('#')[0]）
 *  2. iOS需要使用进入页面的初始URL进行注册，（即在任何pushstate发生前，调用location.href.split('#')[0]）
 * @returns url
 */
export function getConfigUrl() {
	let url = window.location.href.split('#')[0];

	if (isIOS()) {
		url =
			window.sessionStorage.getItem('_iosWXConfig_') ||
			window.location.href.split('#')[0];
	}

	return url;
}

/**
 * jsApi 相关api
 */
export const JsApi = {
	// 通过config接口注入权限验证配置
	/**
	 * 初始化微信JS-SDK
	 * @param callback - 初始化完成后的回调函数
	 * @returns 初始化结果
	 */
	async initJssdk(callback) {
		// 检查是否为微信浏览器
		if (!isWX()) {
			// 如果不是微信浏览器，直接返回null
			return null;
		}

		try {
			// 获取微信签名
			let res = await getSignature(getConfigUrl());
			console.log('获取微信签名 res', res);

			// 配置微信JS-SDK
			wx.config({
				debug: false,
				appId: res.data.appId,
				timestamp: res.data.timestamp,
				nonceStr: res.data.noncestr,
				signature: res.data.signature,
				jsApiList: ['scanQRCode']
			});

			// 微信JS-SDK配置完成后的回调函数
			wx.ready(() => {
				// 设置微信JS-SDK已准备好的状态
				window.sessionStorage.setItem('_wxReady_', true);
				console.log('微信JS-SDK已准备好');

				// 配置完成后，执行传入的回调函数
				if (callback) {
					callback();
				}
			});

			// 微信JS-SDK配置出错时的回调函数
			wx.error(function (res) {
				// 打印错误信息
				console.error('出错了：' + JSON.stringify(res)); // wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
			});
		} catch (error) {
			// 捕获异常，打印错误信息
			console.error('获取调用jsSdk的ticket', error);

			window.sessionStorage.setItem('_wxReady_', false);
			// 返回null，表示初始化失败
			return null;
		}
	},

	scanQRCode() {
		return new Promise((resolve, reject) => {
			if (!window.sessionStorage.getItem('_wxReady_')) {
				// 未准备好
				this.initJssdk(() => _scanQRCode(resolve, reject));
			} else {
				wx.ready(() => {
					// 准备好
					_scanQRCode(resolve, reject);
				});
			}
		});
	}
};

function _scanQRCode(resolve, reject) {
	wx.scanQRCode({
		desc: 'scanQRCode desc',
		needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
		scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
		success: function (res) {
			// 当needResult 为 1 时，扫码返回的结果
			resolve(res.resultStr); // 成功回调，返回扫描结果
		},
		fail: function (res) {
			reject(res); // 失败回调，返回错误信息
		}
	});
}
